/////////////////////////////////////////////////////////
// Configurations related to listing.                  //
// Main configuration here is the extended data config //
/////////////////////////////////////////////////////////

// Note: The listingFields come from listingFields asset nowadays by default.
//       To use this built-in configuration, you need to change the overwrite from configHelper.js
//       (E.g. use mergeDefaultTypesAndFieldsForDebugging func)

/**
 * Configuration options for listing fields (custom extended data fields):
 * - key:                           Unique key for the extended data field.
 * - scope (optional):              Scope of the extended data can be either 'public' or 'private'.
 *                                  Default value: 'public'.
 *                                  Note: listing doesn't support 'protected' scope atm.
 * - schemaType (optional):         Schema for this extended data field.
 *                                  This is relevant when rendering components and querying listings.
 *                                  Possible values: 'enum', 'multi-enum', 'text', 'long', 'boolean'.
 * - enumOptions (optional):        Options shown for 'enum' and 'multi-enum' extended data.
 *                                  These are used to render options for inputs and filters on
 *                                  EditListingPage, ListingPage, and SearchPage.
 * - listingTypeConfig (optional):  Relationship configuration against listing types.
 *   - limitToListingTypeIds:         Indicator whether this listing field is relevant to a limited set of listing types.
 *   - listingTypeIds:                An array of listing types, for which this custom listing field is
 *                                    relevant and should be added. This is mandatory if limitToListingTypeIds is true.
 * - categoryConfig (optional):     Relationship configuration against categories.
 *   - limitToCategoryIds:            Indicator whether this listing field is relevant to a limited set of categories.
 *   - categoryIds:                   An array of categories, for which this custom listing field is
 *                                    relevant and should be added. This is mandatory if limitToCategoryIds is true.
 * - filterConfig:                  Filter configuration for listings query.
 *    - indexForSearch (optional):    If set as true, it is assumed that the extended data key has
 *                                    search index in place. I.e. the key can be used to filter
 *                                    listing queries (then scope needs to be 'public').
 *                                    Note: Sharetribe CLI can be used to set search index for the key:
 *                                    https://www.sharetribe.com/docs/references/extended-data/#search-schema
 *                                    Read more about filtering listings with public data keys from API Reference:
 *                                    https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
 *                                    Default value: false,
 *   - filterType:                    Sometimes a single schemaType can be rendered with different filter components.
 *                                    For 'enum' schema, filterType can be 'SelectSingleFilter' or 'SelectMultipleFilter'
 *   - label:                         Label for the filter, if the field can be used as query filter
 *   - searchMode (optional):         Search mode for indexed data with multi-enum schema.
 *                                    Possible values: 'has_all' or 'has_any'.
 *   - group:                         SearchPageWithMap has grouped filters. Possible values: 'primary' or 'secondary'.
 * - showConfig:                    Configuration for rendering listing. (How the field should be shown.)
 *   - label:                         Label for the saved data.
 *   - isDetail                       Can be used to hide detail row (of type enum, boolean, or long) from listing page.
 *                                    Default value: true,
 * - saveConfig:                    Configuration for adding and modifying extended data fields.
 *   - label:                         Label for the input field.
 *   - placeholderMessage (optional): Default message for user input.
 *   - isRequired (optional):         Is the field required for providers to fill
 *   - requiredMessage (optional):    Message for those fields, which are mandatory.
 */
export const listingFields = [
  // {
  //   "scope": "public",
  //   "label": "Gears",
  //   "key": "gears",
  //   "schemaType": "long",
  //   "numberConfig": {
  //     "minimum": 1,
  //     "maximum": 24
  //   },
  //   "filterConfig": {
  //     "indexForSearch": true,
  //     "group": "primary",
  //     "label": "Gears"
  //   }
  // }
  // {
  //   key: 'bikeType',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: 'city-bikes', label: 'City bikes' },
  //     { option: 'electric-bikes', label: 'Electric bikes' },
  //     { option: 'mountain-bikes', label: 'Mountain bikes' },
  //     { option: 'childrens-bikes', label: "Children's bikes" },
  //   ],
  //   categoryConfig: {
  //     limitToCategoryIds: true,
  //     categoryIds: ['cats'],
  //   },
  //   filterConfig: {
  //     indexForSearch: true,
  //     filterType: 'SelectMultipleFilter', //'SelectSingleFilter',
  //     label: 'Bike type',
  //     group: 'primary',
  //   },
  //   showConfig: {
  //     label: 'Bike type',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Bike type',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to select a bike type.',
  //   },
  // },
  // {
  //   key: 'tire',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: '29', label: '29' },
  //     { option: '28', label: '28' },
  //     { option: '27', label: '27' },
  //     { option: '26', label: '26' },
  //     { option: '24', label: '24' },
  //     { option: '20', label: '20' },
  //     { option: '18', label: '18' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Tire size',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Tire size',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Tire size',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to select a tire size.',
  //   },
  // },
  // {
  //   key: 'brand',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: 'cube', label: 'Cube' },
  //     { option: 'diamant', label: 'Diamant' },
  //     { option: 'ghost', label: 'GHOST' },
  //     { option: 'giant', label: 'Giant' },
  //     { option: 'kalkhoff', label: 'Kalkhoff' },
  //     { option: 'kona', label: 'Kona' },
  //     { option: 'otler', label: 'Otler' },
  //     { option: 'vermont', label: 'Vermont' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Brand',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Brand',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Brand',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to select a brand.',
  //   },
  // },
  // {
  //   key: 'accessories',
  //   scope: 'public',
  //   schemaType: 'multi-enum',
  //   enumOptions: [
  //     { option: 'bell', label: 'Bell' },
  //     { option: 'lights', label: 'Lights' },
  //     { option: 'lock', label: 'Lock' },
  //     { option: 'mudguard', label: 'Mudguard' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Accessories',
  //     searchMode: 'has_all',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Accessories',
  //   },
  //   saveConfig: {
  //     label: 'Accessories',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: false,
  //   },
  // },
  // // An example of how to use transaction type specific custom fields and private data.
  // {
  //   key: 'note',
  //   scope: 'public',
  //   schemaType: 'text',
  //   listingTypeConfig: {
  //     limitToListingTypeIds: true,
  //     listingTypeIds: ['product-selling'],
  //   },
  //   showConfig: {
  //     label: 'Extra notes',
  //   },
  //   saveConfig: {
  //     label: 'Extra notes',
  //     placeholderMessage: 'Some public extra note about this bike...',
  //   },
  // },
  // {
  //   key: 'privatenote',
  //   scope: 'private',
  //   schemaType: 'text',
  //   listingTypeConfig: {
  //     limitToListingTypeIds: true,
  //     listingTypeIds: ['daily-booking'],
  //   },
  //   saveConfig: {
  //     label: 'Private notes',
  //     placeholderMessage: 'Some private note about this bike...',
  //   },
  // },
  // ─── PASSENGER CAPACITY ──────────────────────────────────────────────────
  {
    key: 'passenger_capacity',
    scope: 'public',
    schemaType: 'long',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: [
        'boat-rental',
        'captained-charter-private',
        'captained-charter-ticketed',
        'experience-ticketed',
        'experience-private',
      ],
    },
    filterConfig: {
      indexForSearch: true,
      label: 'Passenger Capacity',
      group: 'primary',
    },
    showConfig: {
      label: 'Max Passengers',
      isDetail: true,
    },
    saveConfig: {
      label: 'Maximum passengers / group size',
      placeholderMessage: 'e.g. 6',
      isRequired: false,
    },
  },
  // ─── MINIMUM PARTICIPANT AGE ──────────────────────────────────────────────
  {
    key: 'minimum_participant_age',
    scope: 'public',
    schemaType: 'long',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: [
        'boat-rental',
        'captained-charter-private',
        'captained-charter-ticketed',
        'experience-ticketed',
        'experience-private',
      ],
    },
    filterConfig: {
      indexForSearch: true,
      label: 'Minimum Participant Age',
      group: 'primary',
    },
    showConfig: {
      label: 'Minimum Participant Age',
      isDetail: true,
    },
    saveConfig: {
      label: 'Minimum participant age',
      placeholderMessage: 'e.g. 0',
      isRequired: false,
    },
  },

  // ─── CONTRACTS / WAIVERS / AGREEMENTS (per listing) ──────────────────────
  // Push 8 Phase A.1 — opt-IN toggle for the BoatersNetwork document signing
  // system. When TRUE, the platform auto-attaches contracts, waivers, and
  // agreements to bookings of this listing, and check-in is gated on
  // document signing. When FALSE, the provider remains responsible for
  // collecting any required documents through their own external process
  // (paper, DocuSign, Smartwaiver, etc.).
  //
  // Required at save time — providers must explicitly answer Yes or No
  // before the Details panel can submit. Phase B-E consumers can read this
  // field as a guaranteed-present boolean.
  //
  // No listingTypeConfig — Cooper's locked decision: every listing type in
  // the marketplace has legitimate document needs (rentals, charters,
  // experiences, services, slip rentals with facility-use waivers, etc.).
  // Providers opt out per-listing via the No answer if their workflow
  // doesn't need platform-handled signing. No category-based gating.
  {
    key: 'boatersnetwork_handles_waivers',
    scope: 'public',
    schemaType: 'boolean',
    helpText:
      'If yes, BoatersNetwork will auto-attach contracts, waivers, and agreements to bookings of this listing, and check-in will be gated on document signing. If no, you remain fully responsible for collecting these documents through your own process — paper, DocuSign, Smartwaiver, or another system.',
    saveConfig: {
      label: 'Will BoatersNetwork handle contracts and waivers for this listing?',
      displayInSignUp: false,
      isRequired: true,
      requiredMessage: 'Please select Yes or No.',
    },
  },

  // ─── INSPECTION DOCUMENTS (Push 9 Sub-phase B) ───────────────────────────
  // Inverse-polarity from boatersnetwork_handles_waivers: default OFF,
  // opt-in by === true. Most providers don't run at-dock inspections;
  // auto-surfacing the Check-In / Check-Out buttons when the provider
  // hasn't explicitly enabled the flow would confuse them. Provider
  // explicitly opts in by setting Yes.
  //
  // Not required at save time (defaults to No / absent — both treated
  // as opt-out by the server gate + the TransactionPanel render
  // predicate). Existing listings continue to function without ever
  // touching this field.
  {
    key: 'uses_inspection_documents',
    scope: 'public',
    schemaType: 'boolean',
    helpText:
      'If yes, BoatersNetwork will surface "Start Check-in" and "Start Check-out" actions on the booking page for this listing — provider and customer each sign their own copy at the start and end of the booking. Disable this if you do not run check-in or check-out procedures.',
    saveConfig: {
      label: 'Use BoatersNetwork check-in and check-out documents for this listing?',
      displayInSignUp: false,
      isRequired: false,
    },
  },

  // ─── CAPTAIN / CREW REQUIREMENTS ─────────────────────────────────────────
  // No listingTypeConfig — these are search-filter-only fields. Omitting listingTypeConfig
  // prevents omitLimitedListingFieldParams from stripping them when pub_listingType is unset
  // (which is the normal state on the "All" tab and when browsing by category).
  {
    key: 'hired_captain_crew_requirements',
    scope: 'public',
    schemaType: 'multi-enum',
    enumOptions: [
      { option: 'no-requirements', label: 'No Captain Required' },
      { option: 'captain-optional-preapproved', label: 'Captain Option Available' },
      { option: 'captain-required-preapproved', label: 'Captain Required (Pre-Approved Only)' },
      { option: 'captain-required-any', label: 'Captain Required (Any Licensed Captain)' },
    ],
    filterConfig: {
      indexForSearch: true,
      searchMode: 'has_any',
    },
    showConfig: {
      label: 'Captain Requirements',
      isDetail: false,
    },
    saveConfig: {
      label: 'Captain / crew requirements',
      placeholderMessage: 'Select an option…',
      isRequired: false,
    },
  },

  // ─── AVAILABLE SLOT DURATIONS ────────────────────────────────────────────
  // Filter-only entry. The field is saved via the Availability panel (hosted Console config).
  // Adding it here makes validURLParamForExtendedData accept pub_available_slot_durations
  // as a valid URL search param so the Private Charters duration filter works.
  // No listingTypeConfig — filter should work across all listing types that set this field.
  {
    key: 'available_slot_durations',
    scope: 'public',
    schemaType: 'multi-enum',
    enumOptions: [
      { option: 'half-hour', label: '30 Minutes' },
      { option: 'one-hour', label: '1 Hour' },
      { option: 'one-half-hour', label: '1.5 Hours' },
      { option: 'two-hour', label: '2 Hours' },
      { option: 'two-half-hour', label: '2.5 Hours' },
      { option: 'three-hour', label: '3 Hours' },
      { option: 'three-half-hour', label: '3.5 Hours' },
      { option: 'four-hour', label: '4 Hours' },
      { option: 'five-hour', label: '5 Hours' },
      { option: 'six-hour', label: '6 Hours' },
      { option: 'seven-hour', label: '7 Hours' },
      { option: 'eight-hour', label: '8 Hours' },
    ],
    filterConfig: {
      indexForSearch: true,
      searchMode: 'has_any',
    },
    showConfig: {
      label: 'Available Slot Durations',
      isDetail: false,
    },
    saveConfig: {
      label: 'Available slot durations',
      isRequired: false,
    },
  },

  // ─── PICKUP / FULFILLMENT OPTIONS ────────────────────────────────────────
  // No listingTypeConfig — same reason as hired_captain_crew_requirements above.
  {
    key: 'pickup_options',
    scope: 'public',
    schemaType: 'multi-enum',
    enumOptions: [
      { option: 'board-at-home-base', label: 'Board at Home Base' },
      { option: 'customer-pickup', label: 'Customer Pickup' },
      { option: 'provider-delivers', label: 'Provider Delivery' },
      { option: 'third-party-ok', label: '3rd Party Delivery' },
      { option: 'customer-tow-away', label: 'Customer Tow-Away' },
    ],
    filterConfig: {
      indexForSearch: true,
      searchMode: 'has_any',
    },
    showConfig: {
      label: 'Pickup / Fulfillment Options',
      isDetail: false,
    },
    saveConfig: {
      label: 'Pickup / fulfillment options',
      isRequired: false,
    },
  },

  // ─── EXPERIENCE ARRIVAL OPTIONS ─────────────────────────────────────────
  {
    key: 'experience_arrival_options',
    scope: 'public',
    schemaType: 'multi-enum',
    enumOptions: [
      { option: 'self-arrival', label: 'Self-Arrival' },
      { option: 'water-pickup', label: 'Water Pickup' },
      { option: 'land-pickup', label: 'Land Pickup' },
      { option: 'equipment-delivery', label: 'Equipment Delivery' },
    ],
    filterConfig: {
      indexForSearch: true,
      searchMode: 'has_any',
    },
    showConfig: {
      label: 'Experience Arrival Options',
      isDetail: false,
    },
    saveConfig: {
      label: 'Experience arrival options',
      isRequired: false,
    },
  },

  // ─── EXPERIENCE MEETING POINT ────────────────────────────────────────────
  {
    key: 'experience_meeting_point',
    scope: 'public',
    schemaType: 'text',
    filterConfig: {
      indexForSearch: false,
    },
    showConfig: {
      label: 'Meeting Point / Launch Location',
      isDetail: false,
    },
    saveConfig: {
      label: 'Meeting point / launch location',
      isRequired: false,
    },
  },

  // ─── BOAT MAKE / MODEL ───────────────────────────────────────────────────
  {
    key: 'boat_make',
    scope: 'public',
    schemaType: 'text',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['boat-rental', 'captained-charter-private', 'captained-charter-ticketed'],
    },
    showConfig: {
      label: 'Boat Make',
      isDetail: false,
    },
    saveConfig: {
      label: 'Boat Make',
      placeholderMessage: 'e.g. Sea Ray, Bayliner, Yamaha',
      isRequired: false,
    },
  },
  {
    key: 'boat_model',
    scope: 'public',
    schemaType: 'text',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['boat-rental', 'captained-charter-private', 'captained-charter-ticketed'],
    },
    showConfig: {
      label: 'Boat Model',
      isDetail: false,
    },
    saveConfig: {
      label: 'Boat Model',
      placeholderMessage: 'e.g. Sundancer 320, Bowrider 175',
      isRequired: false,
    },
  },

  // ─── DELIVERY / FULFILLMENT ──────────────────────────────────────────────
  {
    key: 'home_base_type',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [
      { option: 'marina-slip', label: 'Marina Slip' },
      { option: 'commercial-dock', label: 'Commercial Dock' },
      { option: 'private-hoa-dock', label: 'Private or HOA Dock' },
      { option: 'public-dock-ramp', label: 'Public Dock or Ramp' },
      { option: 'mooring-buoy', label: 'Mooring Buoy' },
      { option: 'on-trailer', label: 'Trailer' },
      { option: 'storefront', label: 'Storefront' },
    ],
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: [
        'boat-rental',
        'captained-charter-private',
        'captained-charter-ticketed',
        'accessory-rental',
      ],
    },
    showConfig: {
      label: 'Home Base Type',
      isDetail: true,
    },
    saveConfig: {
      label: 'Where is the home base / pickup location?',
      isRequired: false,
      requiredMessage: 'Please select a home base type.',
    },
  },
  {
    key: 'approved_destinations',
    scope: 'public',
    schemaType: 'multi-enum',
    enumOptions: [
      { option: 'public-dock-ramp', label: 'Public Dock or Ramp' },
      { option: 'private-hoa-dock', label: 'Private or HOA Dock' },
      { option: 'mooring-buoy', label: 'Private Mooring Buoy' },
      { option: 'trailer-delivery', label: "Customer's Address (trailer delivery)" },
      { option: 'customer-address-land', label: "Customer's Address (land delivery)" },
      { option: 'other', label: 'Other (see delivery notes)' },
    ],
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['boat-rental', 'captained-charter-private', 'accessory-rental'],
    },
    showConfig: {
      label: 'Approved Delivery Destinations',
      isDetail: false,
      unselectedOptions: false,
    },
    saveConfig: {
      label: 'Approved Delivery Destinations',
      isRequired: false,
    },
  },
  {
    key: 'delivery_zone_1_label',
    scope: 'public',
    schemaType: 'text',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['boat-rental', 'captained-charter-private', 'accessory-rental'],
    },
    showConfig: { label: 'Delivery Zone 1 Label', isDetail: false },
    saveConfig: {
      label: 'Delivery Zone 1 — Name (e.g. "Within 10 miles")',
      isRequired: false,
    },
  },
  {
    key: 'delivery_zone_1_fee',
    scope: 'public',
    schemaType: 'long',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['boat-rental', 'captained-charter-private', 'accessory-rental'],
    },
    showConfig: { label: 'Delivery Zone 1 Fee', isDetail: false },
    saveConfig: {
      label: 'Delivery Zone 1 — Fee in cents (e.g. 5000 = $50.00)',
      isRequired: false,
    },
  },
  {
    key: 'delivery_zone_2_label',
    scope: 'public',
    schemaType: 'text',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['boat-rental', 'captained-charter-private', 'accessory-rental'],
    },
    showConfig: { label: 'Delivery Zone 2 Label', isDetail: false },
    saveConfig: {
      label: 'Delivery Zone 2 — Name',
      isRequired: false,
    },
  },
  {
    key: 'delivery_zone_2_fee',
    scope: 'public',
    schemaType: 'long',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['boat-rental', 'captained-charter-private', 'accessory-rental'],
    },
    showConfig: { label: 'Delivery Zone 2 Fee', isDetail: false },
    saveConfig: {
      label: 'Delivery Zone 2 — Fee in cents',
      isRequired: false,
    },
  },
  {
    key: 'delivery_zone_3_label',
    scope: 'public',
    schemaType: 'text',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['boat-rental', 'captained-charter-private', 'accessory-rental'],
    },
    showConfig: { label: 'Delivery Zone 3 Label', isDetail: false },
    saveConfig: {
      label: 'Delivery Zone 3 — Name',
      isRequired: false,
    },
  },
  {
    key: 'delivery_zone_3_fee',
    scope: 'public',
    schemaType: 'long',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['boat-rental', 'captained-charter-private', 'accessory-rental'],
    },
    showConfig: { label: 'Delivery Zone 3 Fee', isDetail: false },
    saveConfig: {
      label: 'Delivery Zone 3 — Fee in cents',
      isRequired: false,
    },
  },
  {
    key: 'delivery_notes',
    scope: 'public',
    schemaType: 'text',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['boat-rental', 'captained-charter-private', 'accessory-rental'],
    },
    showConfig: { label: 'Delivery Notes', isDetail: false },
    saveConfig: {
      label: 'Delivery Notes (visible to customers)',
      placeholderMessage: 'Any additional details about your delivery service…',
      isRequired: false,
    },
  },
  {
    key: 'third_party_notes',
    scope: 'public',
    schemaType: 'text',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['boat-rental', 'captained-charter-private', 'accessory-rental'],
    },
    showConfig: { label: '3rd Party Delivery Notes', isDetail: false },
    saveConfig: {
      label: '3rd Party Delivery Notes (visible to customers)',
      placeholderMessage: 'Recommended delivery services, contact info, tips…',
      isRequired: false,
    },
  },

  // ─── SALES TAX SETTINGS (per listing) ───────────────────────────────────
  {
    key: 'salesTaxRequired',
    scope: 'public',
    schemaType: 'boolean',
    saveConfig: {
      label: 'Do you collect sales tax on bookings of this listing?',
      displayInSignUp: false,
      isRequired: false,
    },
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: [
        'boat-rental',
        'captains-crew-transport',
        'captained-charter-private',
        'captained-charter-ticketed',
        'buoys-moorage-storage',
        'marine-services',
        'accessory-rental',
      ],
    },
  },

  {
    key: 'salesTaxRate',
    scope: 'public',
    schemaType: 'long',
    saveConfig: {
      label: 'Sales tax rate — enter as whole number (e.g. enter 875 for 8.75%)',
      displayInSignUp: false,
      isRequired: false,
    },
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: [
        'boat-rental',
        'captains-crew-transport',
        'captained-charter-private',
        'captained-charter-ticketed',
        'buoys-moorage-storage',
        'marine-services',
        'accessory-rental',
      ],
    },
  },
  {
    key: 'salesTaxJurisdiction',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [
      { option: 'AL', label: 'Alabama' },
      { option: 'AK', label: 'Alaska' },
      { option: 'AZ', label: 'Arizona' },
      { option: 'AR', label: 'Arkansas' },
      { option: 'CA', label: 'California' },
      { option: 'CO', label: 'Colorado' },
      { option: 'CT', label: 'Connecticut' },
      { option: 'DE', label: 'Delaware' },
      { option: 'FL', label: 'Florida' },
      { option: 'GA', label: 'Georgia' },
      { option: 'HI', label: 'Hawaii' },
      { option: 'ID', label: 'Idaho' },
      { option: 'IL', label: 'Illinois' },
      { option: 'IN', label: 'Indiana' },
      { option: 'IA', label: 'Iowa' },
      { option: 'KS', label: 'Kansas' },
      { option: 'KY', label: 'Kentucky' },
      { option: 'LA', label: 'Louisiana' },
      { option: 'ME', label: 'Maine' },
      { option: 'MD', label: 'Maryland' },
      { option: 'MA', label: 'Massachusetts' },
      { option: 'MI', label: 'Michigan' },
      { option: 'MN', label: 'Minnesota' },
      { option: 'MS', label: 'Mississippi' },
      { option: 'MO', label: 'Missouri' },
      { option: 'MT', label: 'Montana' },
      { option: 'NE', label: 'Nebraska' },
      { option: 'NV', label: 'Nevada' },
      { option: 'NH', label: 'New Hampshire' },
      { option: 'NJ', label: 'New Jersey' },
      { option: 'NM', label: 'New Mexico' },
      { option: 'NY', label: 'New York' },
      { option: 'NC', label: 'North Carolina' },
      { option: 'ND', label: 'North Dakota' },
      { option: 'OH', label: 'Ohio' },
      { option: 'OK', label: 'Oklahoma' },
      { option: 'OR', label: 'Oregon' },
      { option: 'PA', label: 'Pennsylvania' },
      { option: 'RI', label: 'Rhode Island' },
      { option: 'SC', label: 'South Carolina' },
      { option: 'SD', label: 'South Dakota' },
      { option: 'TN', label: 'Tennessee' },
      { option: 'TX', label: 'Texas' },
      { option: 'UT', label: 'Utah' },
      { option: 'VT', label: 'Vermont' },
      { option: 'VA', label: 'Virginia' },
      { option: 'WA', label: 'Washington' },
      { option: 'WV', label: 'West Virginia' },
      { option: 'WI', label: 'Wisconsin' },
      { option: 'WY', label: 'Wyoming' },
    ],
    saveConfig: {
      label: 'Which state do you collect sales tax in?',
      displayInSignUp: false,
      isRequired: false,
    },
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: [
        'boat-rental',
        'captains-crew-transport',
        'captained-charter-private',
        'captained-charter-ticketed',
        'buoys-moorage-storage',
        'marine-services',
        'accessory-rental',
      ],
    },
  },
  // Override hosted config: these fields are managed in the Availability tab, not Details.
  // Setting isRequired: false here prevents hasValidListingFieldsInExtendedData from blocking
  // the Details tab completion when these fields are not yet filled in.
  {
    key: 'instant_or_request_booking',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [
      { option: 'instant-book', label: 'Instant booking' },
      { option: 'request-booking', label: 'Request to book' },
    ],
    saveConfig: {
      label: 'Booking type',
      isRequired: false,
    },
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: [
        'boat-rental',
        'captained-charter-private',
        'captained-charter-ticketed',
        'accessory-rental',
      ],
    },
  },
  {
    key: 'minimum_hours',
    scope: 'public',
    schemaType: 'long',
    saveConfig: {
      label: 'Minimum hours',
      isRequired: false,
    },
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: [
        'boat-rental',
        'captained-charter-private',
        'captained-charter-ticketed',
        'accessory-rental',
      ],
    },
  },
  {
    key: 'multiDayListingId',
    scope: 'public',
    schemaType: 'text',
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['boat-rental', 'accessory-rental'],
    },
    showConfig: {
      label: 'Multi-Day Listing ID',
      isDetail: false,
    },
    saveConfig: {
      label: 'Multi-Day Listing ID (optional)',
      placeholderMessage: 'Paste the listing ID of your multi-day rental listing here',
      isRequired: false,
    },
  },
];

///////////////////////////////////////////////////////////////////////
// Configurations related to listing types and transaction processes //
///////////////////////////////////////////////////////////////////////

// A presets of supported listing configurations
//
// Note 1: The listingTypes come from listingTypes asset nowadays by default.
//         To use this built-in configuration, you need to change the overwrite from configHelper.js
//         (E.g. use mergeDefaultTypesAndFieldsForDebugging func)
// Note 2: transaction type is part of listing type. It defines what transaction process and units
//         are used when transaction is created against a specific listing.

/**
 * Configuration options for listing experience:
 * - listingType:         Unique string. This will be saved to listing's public data on
 *                        EditListingWizard.
 * - label                Label for the listing type. Used as microcopy for options to select
 *                        listing type in EditListingWizard.
 * - transactionType      Set of configurations how this listing type will behave when transaction is
 *                        created.
 *   - process              Transaction process.
 *                          The process must match one of the processes that this client app can handle
 *                          (check src/util/transactions/transaction.js) and the process must also exists in correct
 *                          marketplace environment.
 *   - alias                Valid alias for the aforementioned process. This will be saved to listing's
 *                          public data as transctionProcessAlias and transaction is initiated with this.
 *   - unitType             Unit type is mainly used as pricing unit. This will be saved to
 *                          transaction's protected data.
 *                          Recommendation: don't use same unit types in completely different processes
 *                          ('item' sold should not be priced the same as 'item' booked).
 * - stockType            This is relevant only to listings using default-purchase process.
 *                        If set to 'oneItem', stock management is not showed and the listing is
 *                        considered unique (stock = 1).
 *                        Possible values: 'oneItem', 'multipleItems', 'infiniteOneItem', and 'infiniteMultipleItems'.
 *                        Default: 'multipleItems'.
 * - availabilityType     This is relevant only to listings using default-booking process.
 *                        If set to 'oneSeat', seat management is not showed and the listing is
 *                        considered per person (seat = 1).
 *                        Possible values: 'oneSeat' and 'multipleSeats'.
 *                        Default: 'oneSeat'.
 * - priceVariations      This is relevant only to listings using default-booking process.
 *   - enabled:             If set to true, price variations are enabled.
 *                          Default: false.
 * - defaultListingFields These are tied to transaction processes. Different processes have different flags.
 *                        E.g. default-inquiry can toggle price and location to true/false value to indicate,
 *                        whether price (or location) tab should be shown. If defaultListingFields.price is not
 *                        explicitly set to _false_, price will be shown.
 *                        If the location or pickup is not used, listing won't be returned with location search.
 *                        Use keyword search as main search type if location is not enforced.
 *                        The payoutDetails flag allows provider to bypass setting of payout details.
 *                        Note: customers can't order listings, if provider has not set payout details! Monitor
 *                        providers who have not set payout details and contact them to ensure that they add the details.
 * - transactionFields    You can define an array of custom transaction fields for each listing type. Each transaction field
 *                        should have the following attributes:
 *                        - key (string)
 *                        - label (string)
 *                        - showTo (string, options: 'customer', 'provider'). Option 'provider' is only used for negotiation process.
 *                        - schemaType (string, options: 'enum', 'multi-enum', 'text', 'long', 'boolean', 'youtubeVideoUrl')
 *                        - saveConfig (object, optional,  { required: true })
 *                        - schema specific attributes:
 *                          - numberConfig (object, for schemaType: 'long'): { minimum: number, maximum: number }
 *                          - enumOptions (array, for schemaType: 'enum', 'multi-enum'): [{ label: string, option: string }]
 */

export const listingTypes = [
  // ─── BOAT RENTALS ──────────────────────────────────────────
  {
    listingType: 'boat-rental',
    label: 'Boat Rental',
    transactionType: {
      process: 'boatersnetwork-booking',
      alias: 'boatersnetwork-booking/release-1',
      unitType: 'hour',
    },
    availabilityType: 'oneSeat',
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },

  // ─── CAPTAINS, CREW & DELIVERY ─────────────────────────────
  {
    listingType: 'captains-crew-transport',
    label: 'Captains, Crew & Delivery',
    transactionType: {
      process: 'boatersnetwork-booking',
      alias: 'boatersnetwork-booking/release-1',
      unitType: 'hour',
    },
    availabilityType: 'oneSeat',
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },

  // ─── CAPTAINED CHARTER - PRIVATE ───────────────────────────
  {
    listingType: 'captained-charter-private',
    label: 'Private Charter',
    transactionType: {
      process: 'boatersnetwork-booking',
      alias: 'boatersnetwork-booking/release-1',
      unitType: 'hour',
    },
    availabilityType: 'oneSeat',
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },

  // ─── CAPTAINED CHARTER - TICKETED ──────────────────────────
  {
    listingType: 'captained-charter-ticketed',
    label: 'Experience',
    transactionType: {
      process: 'boatersnetwork-booking',
      alias: 'boatersnetwork-booking/release-1',
      unitType: 'fixed',
    },
    availabilityType: 'multipleSeats',
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },

  // ─── BUOYS, SLIPS & STORAGE ────────────────────────────────
  {
    listingType: 'buoys-moorage-storage',
    label: 'Buoys Slips & Storage',
    transactionType: {
      process: 'boatersnetwork-booking',
      alias: 'boatersnetwork-booking/release-1',
      unitType: 'day',
    },
    availabilityType: 'multipleSeats',
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },

  // ─── MARINE SERVICES ───────────────────────────────────────
  {
    listingType: 'marine-services',
    label: 'Marine Services',
    transactionType: {
      process: 'boatersnetwork-booking',
      alias: 'boatersnetwork-booking/release-1',
      unitType: 'fixed',
    },
    availabilityType: 'oneSeat',
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },

  // ─── BOATING ACCESSORIES ───────────────────────────────────
  {
    listingType: 'accessory-rental',
    label: 'Paddle & Gear Rental',
    transactionType: {
      process: 'boatersnetwork-booking',
      alias: 'boatersnetwork-booking/release-1',
      unitType: 'day',
    },
    availabilityType: 'multipleSeats',
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },

  // ─── MULTI-DAY NATIVE LISTINGS (operator-created, hidden from search) ──────
  {
    listingType: 'boat-rental-multiday',
    label: 'Multi-Day Boat Rental',
    transactionType: {
      process: 'default-booking',
      alias: 'default-booking/release-1',
      unitType: 'day',
    },
    availabilityType: 'oneSeat',
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },
  {
    listingType: 'accessory-rental-multiday',
    label: 'Multi-Day Paddle & Gear Rental',
    transactionType: {
      process: 'default-booking',
      alias: 'default-booking/release-1',
      unitType: 'day',
    },
    availabilityType: 'multipleSeats',
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },
];

// SearchPage can enforce listing query to only those listings with valid listingType
// However, it only works if you have set 'enum' type search schema for the public data fields
//   - listingType
//
//  Similar setup could be expanded to 2 other extended data fields:
//   - transactionProcessAlias
//   - unitType
//
// Read More:
// https://www.sharetribe.com/docs/how-to/manage-search-schemas-with-flex-cli/#adding-listing-search-schemas
export const enforceValidListingType = true;
